/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// Chinese
export default {
  'fabric.atlassianSwitcher.switchTo': '切换到',
  'fabric.atlassianSwitcher.switchToTooltip': '切换到…',
  'fabric.atlassianSwitcher.recent': '最近',
  'fabric.atlassianSwitcher.more': '更多',
  'fabric.atlassianSwitcher.try': '尝试',
  'fabric.atlassianSwitcher.manageList': '管理列表',
  'fabric.atlassianSwitcher.jiraProject': 'Jira 项目',
  'fabric.atlassianSwitcher.confluenceSpace': 'Confluence 空间',
  'fabric.atlassianSwitcher.people': '人员',
  'fabric.atlassianSwitcher.administration': '管理',
  'fabric.atlassianSwitcher.discoverMore': '发现更多',
  'fabric.atlassianSwitcher.errorHeading': '出现问题',
  'fabric.atlassianSwitcher.errorText': '我们会跟踪这些错误，但是如果刷新不能修复问题，请随时与我们联系',
  'fabric.atlassianSwitcher.errorImageAltText': '一个损坏的机器人和一些人员正在繁忙修理中。',
  'fabric.atlassianSwitcher.expand': '扩展'
};